import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { IProductDetailNavState } from 'src/app/model/plan/product-detail-nav-state';

/**
 * Protects /plan-coverage-product-detail — requires navigation state with a valid `mode`.
 * Redirects to /plan-coverage if state is missing (e.g. direct URL access or stale bookmark).
 */
export const PlanCoverageProductDetailGuard: CanActivateFn = (): boolean => {
  const router = inject(Router);
  const state = (router.getCurrentNavigation()?.extras?.state ?? history.state) as IProductDetailNavState | null;

  if (!state?.mode) {
    router.navigate(['/plan-coverage']);
    return false;
  }

  return true;
};
